import styled from 'styled-components';
import DealSVG from '../../assets/onboarding/deal.svg';

const Property = styled(DealSVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '4.4rem'};
  height: ${props => props.height || '4.4rem'};
  fill: ${props => props.fill || props.theme.colors.black.base};
`;

export default Property;
